import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export default function ActivityPurchaseGuestDetailTable(props: {
  guestIndex: number;
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.activityPurchases.${props.parentIndex}.activityPurchaseGuests.${props.guestIndex}.activityPurchaseGuestDetails`;

  const { control } = useFormContext();
  const value = useWatch({
    control,
    name,
  });

  const columns = [
    {
      header: t('common:other'),
      accessorKey: 'activityName',
      minSize: 250,
      maxSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:type'),
      accessorKey: 'type',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.null,
    },
    {
      header: t('common:date'),
      accessorKey: 'date',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
